import React, { memo } from 'react';
import { formatCurrency } from '../models/groceryModels';
import './GroceryComponents.css';

const GroceryCartSummary = ({ selectedItems, totalAmount }) => (
  <div className="grocery-summary">
    <div className="grocery-summary-title">Donation Summary</div>

    {selectedItems.length === 0 ? (
      <div className="grocery-summary-empty">
        No items selected yet. Use the + button to add items to your donation.
      </div>
    ) : (
      <>
        <div className="grocery-summary-list">
          {selectedItems.map((item) => (
            <div className="grocery-summary-row" key={item.itemId}>
              <div>
                <div className="grocery-summary-row-name">{item.itemName}</div>
                <div className="grocery-summary-row-qty">
                  {item.quantity} &times; {formatCurrency(item.estimatedPrice)}
                </div>
              </div>
              <div className="grocery-summary-row-amount">
                {formatCurrency(item.quantity * item.estimatedPrice)}
              </div>
            </div>
          ))}
        </div>

        <div className="grocery-summary-divider" />

        <div className="grocery-summary-total">
          <span>Estimated Total</span>
          <span className="grocery-summary-total-value">{formatCurrency(totalAmount)}</span>
        </div>

        <p className="grocery-summary-note">
          Amounts shown are estimated values used for your receipt.
        </p>
      </>
    )}
  </div>
);

export default memo(GroceryCartSummary);
